/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import {useEffect, useMemo, useRef, useState} from 'react';
import { css } from '@emotion/css';
import { Analyser } from '../utils/analyser';

interface VisualsCircleProps {
  inputNode: AudioNode;
  outputNode: AudioNode;
}

export function VisualsCircle({outputNode}: VisualsCircleProps) {
  const [scale, setScale] = useState(1);
  const animationFrameId = useRef<number | null>(null);

  const outputAnalyser = useMemo(() => new Analyser(outputNode), [outputNode]);

  useEffect(() => {
    if (!outputNode) {
      return;
    }
    
    const animate = () => {
      outputAnalyser.update();
      const newScale = 1 + (0.4 * outputAnalyser.data[1]) / 255;
      setScale(newScale);
      animationFrameId.current = requestAnimationFrame(animate);
    };

    animationFrameId.current = requestAnimationFrame(animate);

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [outputAnalyser, outputNode]);

  return <div className={css`
    width: 291px;
    height: 291px;
    background-color: #D9D9D9;
    border-radius: 50%;
    transform: scale(${scale});
    margin: 0 auto;

    transition: all 0.1s ease-out;
  `} />;
} 